import { render, staticRenderFns } from "./IngestTooltip.vue?vue&type=template&id=42539ae7&scoped=true"
import script from "./IngestTooltip.vue?vue&type=script&lang=js"
export * from "./IngestTooltip.vue?vue&type=script&lang=js"
import style0 from "./IngestTooltip.vue?vue&type=style&index=0&id=42539ae7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42539ae7",
  null
  
)

export default component.exports